/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFileInvoice = createReactComponent("file-invoice", "IconFileInvoice", [
  ["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }],
  [
    "path",
    {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M9 7l1 0", key: "svg-2" }],
  ["path", { d: "M9 13l6 0", key: "svg-3" }],
  ["path", { d: "M13 17l2 0", key: "svg-4" }]
]);

export { IconFileInvoice as default };
//# sourceMappingURL=IconFileInvoice.js.map
